<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on="on" v-bind="attrs" color="error"
        ><v-icon>mdi-alert-circle-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Produto com erro</v-card-title>
      <v-card-subtitle>Verifique os erros abaixo</v-card-subtitle>
      <v-card-text>
        <ul class="subtitle-1">
          <li v-for="(erro, i) in produto.erros" :key="i">{{ erro }}</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    produto: Object,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>